import AscAdminContainer from './containers/AscAdminContainer'
import AscAnalyticContainer from './containers/AscAnalyticContainer'
import AscFeatureFlagsContainer from './containers/AscFeatureFlagsContainer'
import AscDocMgmtContainer from './containers/AscDocMgmtContainer'
import AscAirlineMgmtContainer from './containers/AscAirlineMgmtContainer'
import AscRoleContainer from './containers/AscRoleContainer'
import AscUserRoleContainer from './containers/AscUserRoleContainer'
import { role } from '@/utilities/userRoles'

const adminRouter = {
  name: 'Admin',
  path: '/admin',
  component: AscAdminContainer,
  meta: {
    requiresRole: [
      role.userManager,
      role.analyticAdmin,
      role.documentManager,
      role.airlineManager,
      role.userReader,
    ],
    breadcrumbs: [
      {
        text: 'Home',
        to: '/',
      },
      {
        text: 'Admin',
      },
    ],
  },
  children: [
    {
      path: 'user',
      name: 'User Management',
      component: AscUserRoleContainer,
      meta: {
        requiresRole: [role.userManager, role.userReader],
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Admin',
          },
        ],
      },
    },
    {
      path: 'analytic',
      name: 'Analytic Management',
      component: AscAnalyticContainer,
      meta: {
        requiresRole: role.analyticAdmin,
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Admin',
          },
        ],
      },
    },
    {
      path: 'feature-flags',
      name: 'Feature Flags',
      component: AscFeatureFlagsContainer,
      meta: {
        requiresRole: role.admin,
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Admin',
            to: '/admin',
          },
          {
            text: 'Feature Flags',
          },
        ],
      },
    },
    {
      path: 'document',
      name: 'Document Management',
      component: AscDocMgmtContainer,
      meta: {
        requiresRole: role.documentManager,
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Admin',
          },
        ],
      },
    },
    {
      path: 'airline',
      name: 'Airline Management',
      component: AscAirlineMgmtContainer,
      meta: {
        requiresRole: role.airlineManager,
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Admin',
          },
        ],
      },
    },
    {
      path: 'role',
      name: 'Role Management',
      component: AscRoleContainer,
      meta: {
        requiresRole: role.userManager,
        breadcrumbs: [
          {
            text: 'Home',
            to: '/',
          },
          {
            text: 'Admin',
          },
        ],
      },
    },
  ],
}

export default adminRouter
